import { api } from "@/lib/orgApi";

const BASE = "/form-designer";

/**
 * Bindable fields of ONE primary table. Form Designer asks for the table the
 * user picked rather than downloading every table definition to populate one
 * form. Sensitive columns are excluded by the backend catalog.
 */
export function getBindableFields(schema, name) {
  return api
    .get(`${BASE}/fields/${encodeURIComponent(schema)}/${encodeURIComponent(name)}`)
    .then((response) => response.data || {});
}

export function listFormDesigns() {
  return api.get(`${BASE}/forms`).then((response) => response.data || {});
}

export function getFormDesign(id) {
  return api.get(`${BASE}/forms/${encodeURIComponent(id)}`).then((response) => response.data || {});
}

export function saveFormDesign(payload) {
  return api.post(`${BASE}/forms`, payload).then((response) => response.data || {});
}

export function deleteFormDesign(id) {
  return api.delete(`${BASE}/forms/${encodeURIComponent(id)}`).then((response) => response.data || {});
}
